import { defineMessages } from 'react-intl';

export default defineMessages({

  tripCancellation: {
    id: 'fastCover.tripCancellationCFStep.tripCancellation',
    defaultMessage: 'Are you claiming for Trip Cancellation?',
  },

  reasonsForTripCancellation: {
    id: 'fastCover.tripCancellationCFStep.reasonsForTripCancellation',
    defaultMessage: 'Reasons for Trip Cancellation',
  },

  haveYouReceivedReimbursement: {
    id: 'fastCover.tripCancellationCFStep.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received reimbursement?',
  },

  travelInterruption: {
    id: 'fastCover.tripCancellationCFStep.travelInterruption',
    defaultMessage: 'Are you claiming for Trip Interruption?',
  },

  travelDelay: {
    id: 'fastCover.tripCancellationCFStep.travelDelay',
    defaultMessage: 'Are you claiming for Travel Delay?',
  },

  reasonsForTripInterruption: {
    id: 'fastCover.tripCancellationCFStep.reasonsForTripInterruption',
    defaultMessage: 'Reasons for Trip Interruption',
  },

  reasons1: {
    id: 'fastCover.tripCancellationCFStep.reasons1',
    defaultMessage: 'Death of an Immediate Family Member',
  },

  reasons2: {
    id: 'fastCover.tripCancellationCFStep.reasons2',
    defaultMessage: 'Your Unforeseen Sickness or Injury or, the Sickness or Injury of a Traveling Companion or Immediate Family Member',
  },

  reasons3: {
    id: 'fastCover.tripCancellationCFStep.reasons3',
    defaultMessage: 'Substantial destruction of your principal residence by fire or weather-related activity',
  },

  reasons4: {
    id: 'fastCover.tripCancellationCFStep.reasons4',
    defaultMessage: 'A Medically Necessary covered Emergency Medical Evacuation to return to Your Home Country or to the area from which You were initially evacuated for continued treatment, recuperation, and recovery',
  },

  reasons5: {
    id: 'fastCover.tripCancellationCFStep.reasons5',
    defaultMessage: 'Any other medical reason',
  },

  companyNameTravelInterruption: {
    id: 'fastCover.tripCancellationCFStep.companyNameTravelInterruption',
    defaultMessage: 'Company Name',
  },

  addressTravelInterruption: {
    id: 'fastCover.tripCancellationCFStep.addressTravelInterruption',
    defaultMessage: 'Address',
  },

  cityTravelInterruption: {
    id: 'fastCover.tripCancellationCFStep.cityTravelInterruption',
    defaultMessage: 'City',
  },

  stateTravelInterruption: {
    id: 'fastCover.tripCancellationCFStep.stateTravelInterruption',
    defaultMessage: 'State',
  },

  zipCodeTravelInterruption: {
    id: 'fastCover.tripCancellationCFStep.zipCodeTravelInterruption',
    defaultMessage: 'Zip code',
  },

  contactTravelInterruption: {
    id: 'fastCover.tripCancellationCFStep.contactTravelInterruption',
    defaultMessage: 'Contact',
  },

  phoneNumberTravelInterruption: {
    id: 'fastCover.tripCancellationCFStep.phoneNumberTravelInterruption',
    defaultMessage: 'Phone Number',
  },

  includedInPackage: {
    id: 'fastCover.tripCancellationCFStep.includedInPackage',
    defaultMessage: 'If not included in package, how was air travel arranged?',
  },

  lossInformation: {
    id: 'fastCover.tripCancellationCFStep.lossInformation',
    defaultMessage: 'Loss Information',
  },

  addLossInformation: {
    id: 'fastCover.tripCancellationCFStep.addLossInformation',
    defaultMessage: 'Add Loss Information',
  },

  dateTripInterrupted: {
    id: 'fastCover.tripCancellationCFStep.dateTripInterrupted',
    defaultMessage: 'Date Trip was Interrupted',
  },

  lossInformationWithIdx: {
    id: 'fastCover.tripCancellationCFStep.lossInformationWithIdx',
    defaultMessage: 'Loss information {idx}',
  },

  reasonForInterruption: {
    id: 'fastCover.tripCancellationCFStep.reasonForInterruption',
    defaultMessage: 'Reason for interruption',
  },

  nameOfPersonHavingSickness: {
    id: 'fastCover.tripCancellationCFStep.nameOfPersonHavingSickness',
    defaultMessage: 'Name of person having sickness of injury',
  },

  dateOfBirth: {
    id: 'fastCover.tripCancellationCFStep.dateOfBirth',
    defaultMessage: 'His/Her date of birth',
  },

  relationshipToClaimant: {
    id: 'fastCover.tripCancellationCFStep.relationshipToClaimant',
    defaultMessage: 'His/Her relationship to claimant',
  },

  dateSicknessOrInjuryBegan: {
    id: 'fastCover.tripCancellationCFStep.dateSicknessOrInjuryBegan',
    defaultMessage: 'Date Sickness Or Injury began',
  },

  dateEnded: {
    id: 'fastCover.tripCancellationCFStep.dateEnded',
    defaultMessage: 'Date ended',
  },

  natureOfSicknessOrInjury: {
    id: 'fastCover.tripCancellationCFStep.natureOfSicknessOrInjury',
    defaultMessage: 'Nature of Sickness or Injury (If Injury, describe accident, including date and place):',
  },

  periodOfHospitalization: {
    id: 'fastCover.tripCancellationCFStep.periodOfHospitalization',
    defaultMessage: 'Period of hospitalization (If applicable)',
  },

  companyNameLoss: {
    id: 'fastCover.tripCancellationCFStep.companyNameLoss',
    defaultMessage: 'Company name (airline/hotel/cruise/travel agent/etc.)',
  },

  amountPaidLoss: {
    id: 'fastCover.tripCancellationCFStep.amountPaidLoss',
    defaultMessage: 'Amount Paid',
  },

  amountOfLoss: {
    id: 'fastCover.tripCancellationCFStep.amountOfLoss',
    defaultMessage: 'Amount of Loss (non-refundable amount)',
  },

  howMuchReceivedReimbursement: {
    id: 'fastCover.tripCancellationCFStep.howMuchReceivedReimbursement',
    defaultMessage: 'How much?',
  },

  fromWhom: {
    id: 'fastCover.tripCancellationCFStep.fromWhom',
    defaultMessage: 'If so, from whom?',
  },

  reasonsForDelay: {
    id: 'fastCover.tripCancellationCFStep.reasonsForDelay',
    defaultMessage: 'Reasons for Delay',
  },

  reasons1ForTravelDelay: {
    id: 'fastCover.tripCancellationCFStep.reasons1ForTravelDelay',
    defaultMessage: 'Delay of a Common Carrier (including Inclement Weather)',
  },

  reasons2ForTravelDelay: {
    id: 'fastCover.tripCancellationCFStep.reasons2ForTravelDelay',
    defaultMessage: 'Delay by a traffic Accident enroute to a departure, in which You or Your Traveling Companion is not directly involved',
  },

  reasons3ForTravelDelay: {
    id: 'fastCover.tripCancellationCFStep.reasons3ForTravelDelay',
    defaultMessage: 'Delay due to lost or stolen passport, travel documents or money, Quarantine, hijacking, unannounced Strike, Natural Disaster, civil commotion, or riot',
  },

  reasons4ForTravelDelay: {
    id: 'fastCover.tripCancellationCFStep.reasons4ForTravelDelay',
    defaultMessage: 'A closed roadway causing cessation of travel to the destination of the Trip (substantiated by the department of transportation, state police, etc.)',
  },

  dateOfInitialPaymentDeposit: {
    id: 'fastCover.tripCancellationCFStep.dateOfInitialPaymentDeposit',
    defaultMessage: 'Date of initial payment deposit',
  },

  dateYouWereDueToDepart: {
    id: 'fastCover.tripCancellationCFStep.dateYouWereDueToDepart',
    defaultMessage: 'Date you were due to depart',
  },

  timeYouWereDueToDepart: {
    id: 'fastCover.tripCancellationCFStep.timeYouWereDueToDepart',
    defaultMessage: 'Time you were due to depart',
  },

  dateTripWasDelayed: {
    id: 'fastCover.tripCancellationCFStep.dateTripWasDelayed',
    defaultMessage: 'Date trip was delayed with Travel Supplier',
  },

  dateDelayEnded: {
    id: 'fastCover.tripCancellationCFStep.dateDelayEnded',
    defaultMessage: 'Date delay ended',
  },

  dateYouActuallyDeparted: {
    id: 'fastCover.tripCancellationCFStep.dateYouActuallyDeparted',
    defaultMessage: 'Date you actually departed',
  },

  timeYouActuallyDeparted: {
    id: 'fastCover.tripCancellationCFStep.timeYouActuallyDeparted',
    defaultMessage: 'Time you actually departed',
  },

  delayInformation: {
    id: 'fastCover.tripCancellationCFStep.delayInformation',
    defaultMessage: 'Delay Information',
  },

  addDelayInformation: {
    id: 'fastCover.tripCancellationCFStep.addDelayInformation',
    defaultMessage: 'Add Delay Information',
  },

  delayInformationWithIdx: {
    id: 'fastCover.tripCancellationCFStep.delayInformationWithIdx',
    defaultMessage: 'Delay information {idx}',
  },
  dateReimbursementReceived: {
    id: 'fastCover.tripCancellationCFStep.dateReimbursementReceived',
    defaultMessage: 'Date Reimbursement Received',
  },

  yes: {
    id: 'fastCover.tripCancellationCFStep.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.tripCancellationCFStep.no',
    defaultMessage: 'No',
  },
  fromDate: {
    id: 'fastCover.tripCancellationCFStep.fromDate',
    defaultMessage: 'From Date',
  },
  toDate: {
    id: 'fastCover.tripCancellationCFStep.toDate',
    defaultMessage: 'To Date',
  },

  //-----------------------------------------------------------------------------------------

  howItHappened: {
    id: 'fastCover.tripCancellationCFStep.howItHappened',
    defaultMessage: '1. How it happened',
  },
  whereYouWereInRelationToTheItem: {
    id: 'fastCover.tripCancellationCFStep.whereYouWereInRelationToTheItem',
    defaultMessage:
      'Provide details of where you were in relation to the item at the time of loss, theft or damage',
  },
  anyThingAdditionalToAdd: {
    id: 'fastCover.tripCancellationCFStep.anyThingAdditionalToAdd',
    defaultMessage: 'Do you have any further details to add?',
  },
  areYouClaimingFor: {
    id: 'fastCover.tripCancellationCFStep.areYouClaimingFor',
    defaultMessage: 'Are you claiming for',
  },
  loss: {
    id: 'fastCover.tripCancellationCFStep.loss',
    defaultMessage: 'Loss',
  },
  theft: {
    id: 'fastCover.tripCancellationCFStep.theft',
    defaultMessage: 'Theft',
  },
  damage: {
    id: 'fastCover.tripCancellationCFStep.damage',
    defaultMessage: 'Damage',
  },
  delay: {
    id: 'fastCover.tripCancellationCFStep.delay',
    defaultMessage: 'Delay',
  },
  whoDidYouReportThisTo: {
    id: 'fastCover.tripCancellationCFStep.whoDidYouReportThisTo',
    defaultMessage: 'Who did you report this to?',
  },
  police: {
    id: 'fastCover.tripCancellationCFStep.police',
    defaultMessage: 'Police',
  },
  hotelManagement: {
    id: 'fastCover.tripCancellationCFStep.hotelManagement',
    defaultMessage: 'Hotel Management',
  },
  cruiseShip: {
    id: 'fastCover.tripCancellationCFStep.cruiseShip',
    defaultMessage: 'Cruise Ship',
  },
  airline: {
    id: 'fastCover.tripCancellationCFStep.airline',
    defaultMessage: 'Airline',
  },
  tourGuide: {
    id: 'fastCover.tripCancellationCFStep.tourGuide',
    defaultMessage: 'Tour Guide',
  },
  other: {
    id: 'fastCover.tripCancellationCFStep.other',
    defaultMessage: 'Other',
  },
  notReported: {
    id: 'fastCover.tripCancellationCFStep.notReported',
    defaultMessage: 'Not Reported',
  },
  otherDescription: {
    id: 'fastCover.tripCancellationCFStep.otherDescription',
    defaultMessage: 'If other, please describe',
  },
  reportReferenceNumber: {
    id: 'fastCover.tripCancellationCFStep.reportReferenceNumber',
    defaultMessage: 'Report Reference Number',
  },
  descriptionOfItem: {
    id: 'fastCover.tripCancellationCFStep.descriptionOfItem',
    defaultMessage: 'Description of item',
  },
  datePurchased: {
    id: 'fastCover.tripCancellationCFStep.datePurchased',
    defaultMessage: 'Date purchased',
  },
  storeWhereItemWasPurchased: {
    id: 'fastCover.tripCancellationCFStep.storeWhereItemWasPurchased',
    defaultMessage: 'Store where item was purchased',
  },
  purchasePrice: {
    id: 'fastCover.tripCancellationCFStep.purchasePrice',
    defaultMessage: 'Purchase price',
  },
  currency: {
    id: 'fastCover.tripCancellationCFStep.currency',
    defaultMessage: 'Currency',
  },
  amountClaimed: {
    id: 'fastCover.tripCancellationCFStep.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  proofOfPurchaseAttached: {
    id: 'fastCover.tripCancellationCFStep.proofOfPurchaseAttached',
    defaultMessage: 'Proof of purchase attached',
  },
  addAdditionalItem: {
    id: 'fastCover.tripCancellationCFStep.addAdditionalItem',
    defaultMessage: 'Add Additional Item',
  },
  additionalItem: {
    id: 'fastCover.tripCancellationCFStep.additionalItem',
    defaultMessage: 'Luggage and Personal Items',
  },
  item: {
    id: 'fastCover.tripCancellationCFStep.item',
    defaultMessage: 'Item',
  },
  claimed: {
    id: 'fastCover.tripCancellationCFStep.claimed',
    defaultMessage: 'Claimed',
  },
  nameOfTransportProvider: {
    id: 'fastCover.tripCancellationCFStep.nameOfTransportProvider',
    defaultMessage:
      'Name of Transport Provider (airline, cruise liner, bus etc.)',
  },
  dateWhenYourLuggageWasDelayed: {
    id: 'fastCover.tripCancellationCFStep.dateWhenYourLuggageWasDelayed',
    defaultMessage: 'Date when your luggage was delayed',
  },
  timeWhenYourLuggageWasDelayed: {
    id: 'fastCover.tripCancellationCFStep.timeWhenYourLuggageWasDelayed',
    defaultMessage: 'Time when your luggage was delayed',
  },
  dateWhenYourLuggageWasReturned: {
    id: 'fastCover.tripCancellationCFStep.dateWhenYourLuggageWasReturned',
    defaultMessage: 'Date when your luggage was returned',
  },
  timeWhenYourLuggageWasReturned: {
    id: 'fastCover.tripCancellationCFStep.timeWhenYourLuggageWasReturned',
    defaultMessage: 'Time when your luggage was returned',
  },
  paidForDelay: {
    id: 'fastCover.tripCancellationCFStep.paidForDelay',
    defaultMessage: 'Were you paid any compensation for this delay?',
  },
  madeClaimWithTravelProviderOrOther: {
    id: 'fastCover.tripCancellationCFStep.madeClaimWithTravelProviderOrOther',
    defaultMessage:
      'Have you made a claim with your Travel Provider (Airline, hotel, cruise liner, tour company etc.) or any other company responsible for the loss, theft, damage or delay of your luggage?',
  },
  listedOnThePolicy: {
    id: 'fastCover.tripCancellationCFStep.listedOnThePolicy',
    defaultMessage:
      'Are the luggage or personal item(s) lost, stolen, damaged or delayed owned by you or someone else listed on the policy?',
  },
  damagedLostOrStolenLuggageItems: {
    id: 'fastCover.tripCancellationCFStep.damagedLostOrStolenLuggageItems',
    defaultMessage: 'Damaged, Lost or Stolen Luggage Items',
  },
  delayedLuggageExpenses: {
    id: 'fastCover.tripCancellationCFStep.delayedLuggageExpenses',
    defaultMessage: 'Delayed Luggage Expenses',
  },
  delayedLuggageExpense: {
    id: 'fastCover.tripCancellationCFStep.delayedLuggageExpense',
    defaultMessage: 'Delayed Luggage Expense',
  },
  isRequired: {
    id: 'fastCover.tripCancellationCFStep.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  expenseTableRequired: {
    id: 'fastCover.tripCancellationCFStep.expenseTableRequired',
    defaultMessage: 'Expense table fields are mandatory fields.',
  },
  addDelayedLuggageExpense: {
    id: 'fastCover.tripCancellationCFStep.addDelayedLuggageExpense',
    defaultMessage: 'Add Delayed Luggage Expense',
  },
  dateCompensationWasReceived: {
    id: 'fastCover.tripCancellationCFStep.dateCompensationWasReceived',
    defaultMessage: 'Date compensation was received',
  },
  compensationDescription: {
    id: 'fastCover.tripCancellationCFStep.compensationDescription',
    defaultMessage: 'Compensation description',
  },
  amountOfCompensation: {
    id: 'fastCover.tripCancellationCFStep.delayedTravel.amountOfCompensation',
    defaultMessage: 'Compensation received',
  },
  amountOfCompensationCurrency: {
    id: 'fastCover.tripCancellationCFStep.delayedTravel.amountOfCompensationCurrency',
    defaultMessage: 'Currency',
  },
  currencyEg: {
    id: 'fastCover.tripCancellationCFStep.currencyEg',
    defaultMessage: 'E.g.Euro',
  },
  other1: {
    id: 'fastCover.tripCancellationCFStep.other1',
    defaultMessage: 'Proof of loss (i.e. police report, report to hotel, airline, transport provider)',
  },
  other2: {
    id: 'fastCover.tripCancellationCFStep.other2',
    defaultMessage: 'Proof of ownership/receipts/bank statements for each item',
  },
  other3: {
    id: 'fastCover.tripCancellationCFStep.other3',
    defaultMessage: 'Written confirmation of an IMEI block from your network provider',
  },
  other4: {
    id: 'fastCover.tripCancellationCFStep.other4',
    defaultMessage: 'A damage/repair report or quotation',
  },
  other5: {
    id: 'fastCover.tripCancellationCFStep.other5',
    defaultMessage: 'Written confirmation of luggage delay',
  },
  other6: {
    id: 'fastCover.tripCancellationCFStep.other6',
    defaultMessage: 'Receipts, bank statements and/or proof of payment for each expense being claimed',
  },
  itemWithIdx: {
    id: 'fastCover.tripCancellationCFStep.itemWithIdx',
    defaultMessage: 'Item {idx}',
  },
  delayedLuggageExpenseWithIdx: {
    id: 'fastCover.tripCancellationCFStep.delayedLuggageExpenseWithIdx',
    defaultMessage: 'Delayed Luggage Expense {idx}',
  },
  checkEventDate: {
    id: 'fastCover.tripCancellationCFStep.checkEventDate',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },
  detailsRegardingYourTripDelay: {
    id: 'fastCover.tripCancellationCFStep.detailsRegardingYourTripDelay',
    defaultMessage: 'Details regarding your Trip Delay',
  },
  dateTripWasDelayedWithTravelSupplier: {
    id: 'fastCover.tripCancellationCFStep.dateTripWasDelayedWithTravelSupplier',
    defaultMessage: 'Date Trip was delayed with Travel Supplier',
  },
  dateOfExpenses: {
    id: 'fastCover.tripCancellationCFStep.dateOfExpenses',
    defaultMessage: 'Date Of Expenses',
  },
  areYouCancellingTheTripDueToMedicalReasons: {
    id: 'fastCover.medicalExpenseStep.areYouCancellingTheTripDueToMedicalReasons',
    defaultMessage: 'Are you cancelling the trip due to medical reasons?',
  },
  insureds: {
    id: 'fastCover.tripCancellationCFStep.addInsured',
    defaultMessage: 'Name(s) and birth dates of all claimants:',
  },
  travelSupplier: {
    id: 'fastCover.tripCancellationCFStep.travelSupplier',
    defaultMessage: 'Travel Supplier / Provider Information',
  },
  dateTripWasCancelledWithTravelSupplier: {
    id: 'fastCover.tripCancellationCFStep.dateTripWasCancelledWithTravelSupplier',
    defaultMessage: 'Date Trip was cancelled with Travel Supplier',
  },
  reasonForCancellation: {
    id: 'fastCover.tripCancellationCFStep.reasonForCancellation',
    defaultMessage: 'Reason For Cancellation',
  },
  tripCancellationForAnyReason: {
    id: 'fastCover.tripCancellationCFStep.tripCancellationForAnyReason',
    defaultMessage: 'Are you claiming Trip Cancellation for Any Reason?',
  },
  addInsured: {
    id: 'fastCover.tripCancellationCFStep.addInsured',
    defaultMessage: 'Add Insured',
  },
  birthDay: {
    id: 'fastCover.tripCancellationCFStep.birthDay',
    defaultMessage: 'Birth Day',
  },
  fullName: {
    id: 'fastCover.tripCancellationCFStep.fullName',
    defaultMessage: 'Full Name',
  },
  insuredInformationWithIdx: {
    id: 'fastCover.tripCancellationCFStep.insuredInformationWithIdx',
    defaultMessage: 'Insured Information {idx}',
  },
  areYouInterruptingTheTripDueToMedicalReasons: {
    id: 'fastCover.tripCancellationCFStep.areYouInterruptingTheTripDueToMedicalReasons',
    defaultMessage: 'Are you interrupting the trip due to medical reasons?',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.CFTripCan.TripCancellationStep/messages.js